import routerOptions0 from "/app01/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app01/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}